import React, { useEffect, useState, type ReactElement } from 'react';
import { AdMob } from '@capacitor-community/admob';
import { Capacitor } from '@capacitor/core';
import InitAdmob from 'helpers/InitAdmob';
import LoadCookieConsentAndAds from 'helpers/LoadCookieConsentAndAds';
import { isCrawler, isCurrentUserPremium } from 'helpers/authentication';
import useAppLifecycle from 'helpers/useAppLifecycle';
import useAppUrlListener from 'helpers/useAppUrlListener';
import { usePushNotifications } from 'helpers/usePushNotifications';
import useScrollToTop from 'helpers/useScrollToTop';
import ClarityLoader from 'ui/design-base/ClarityLoader';
import CleverCoreLoader from 'ui/design-base/CleverCoreLoader';
import { initCleverTap } from './clevertapService';
import { onUserLogin } from './crmUtils';
import useCookieConsent from './useCookieConsent';
import { getClevertapWebInitConditions } from './utils';

const LoadSentry = React.lazy(() => import('helpers/LoadSentry'));

const WrapNewUi = ({ children }: { children: ReactElement | null }) => {
  const [shouldLoadSentry] = useState(() => Math.random() < 0.1);
  usePushNotifications();
  useAppLifecycle();
  useAppUrlListener();
  useScrollToTop();
  const { cookieLoaded } = useCookieConsent();

  useEffect(() => {
    if (getClevertapWebInitConditions()) {
      initCleverTap().then((clevertap) => {
        if (clevertap) {
          onUserLogin();
        }
      });
    }
  }, []);

  if (isCurrentUserPremium() && Capacitor.isNativePlatform()) {
    try {
      AdMob.removeBanner();
    } catch (e) {
      console.warn(e);
    }
  }

  return (
    <>
      {!Capacitor.isNativePlatform() && (
        <React.Suspense fallback={<></>}>{shouldLoadSentry && <LoadSentry />}</React.Suspense>
      )}
      {!isCrawler() && <ClarityLoader />}
      {isCurrentUserPremium() || isCrawler() ? (
        <></>
      ) : Capacitor.isNativePlatform() ? (
        <InitAdmob />
      ) : (
        <>
          <LoadCookieConsentAndAds cookieLoaded={cookieLoaded} />
          <CleverCoreLoader />
        </>
      )}
      {children}
    </>
  );
};

export default WrapNewUi;
